import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { finalize, catchError } from 'rxjs/operators';
import { LoaderService } from '../Servcie/loader.service';

@Injectable({ providedIn: 'root' })
export class InterceptorService implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.showLoader();

    const token = this.getToken();
    let authReq = req;
    if (token) {
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        let errorMsg =
          error.error instanceof ErrorEvent
            ? `Client Error: ${error.error.message}`
            : `Server Error: ${error.status} - ${error.message}`;

        console.error(errorMsg);
        return throwError(() => new Error(errorMsg));
      }),
      finalize(() => {
        this.loaderService.hideLoader();
      }),
    );
  }

  getToken(): string | null {
    return sessionStorage.getItem('token');
  }
}
